import React from "react";
const config = require("../config");
const helper = require("../helper");
const Modal = require("../comp_misc").modal;
const helperFile = require("./user_helper.js");
const Pager = require("../comp_misc").pager;

// https://reactjs.org/docs/lists-and-keys.html react lists


var g_link = "/user/courses";

function ListItem(props) {
  // Correct! There is no need to specify the key here:
  return <tr>
    <td><img src="/icon-rvsm.svg" width="50" height="50" alt="RVSM"/></td><td><button type="button" onClick={() => {window.location="/user/course_content?id="+props.item.id}} class="btn btn-outline-primary">Start</button></td><td>{props.item.ref}</td>
<td>{props.item.name}</td>
<td>{props.item.className}</td>
<td>{props.item.validity}</td>
<td>{props.item.expireDate}</td>
<td>{props.item.lastAttempt}</td>
<td>{props.item.daysLeft}</td>
<td><img src={"/status-"+props.item.statusColor+".svg"} width="30" height="30"/></td>

</tr>

}

class ModalList1 extends React.Component {
  
  constructor(props)
  {
    super(props);
    this.state = {
      show: false,
      rows: null,
      name:null,
      email:"",
      error:null,
      image: null,
    };
  }




fillList()
{
  var rows1 = [];

  helper.getFromServer(g_link+"?dw=get")
  .then(res => {

    this.setState({showForm: false, rows: res.result, options: res.options, count: res.options.count});
  })



}
 componentDidMount() {
  this.fillList()  
  }

    

  render() {
document.title = "Courses";

let spinner;
let pager;
if (!this.state.rows)
{
  spinner = <div class="d-flex justify-content-center">
  <div class="spinner-border spinner text-primary" role="status">
      <span class="sr-only">Loading...</span>
  </div>
</div>;
}
else
{
  pager = <Pager page={this.state.page} count={this.state.options.count} link={g_link}/>;
}


let listItems;
if (this.state.rows)
{


  listItems = this.state.rows.map((item, index) =>

    <ListItem key={index} item={item} parent={this} />
  );

}
return(
<div>
{helperFile.nav()}

    <div class="container my-4">
        <h2 class="text-primary mb-4"><i class="fa fa-database mr-2" aria-hidden="true"></i>Courses</h2>


        <div class="data-container">
            <div class="row mb-2">
                <div class="col-8">
                    <p>This screen displays all your crew members sorted by name in Alphabetical order. To view each crew member specific records, click on the View button. You may filter your crew by Group, Rank and Aircraft Type.</p>
                </div>
                <div class="col-4">
                    <div class="card bg-secondary">
                        <div class="card-body text-center font-weight-bolder text-white">
                        Courses: {this.state.count}
                        </div>
                    </div>
                </div>
            </div>
            <hr/>

            

            <div class="row">
                <div class="col-xl-12 col-lg-12 col-md-12 col-12">
                    <table class="table mb-0 table-hover">
                      <thead>
                        <tr>
                          <th scope="col"  >#</th>
                          <th scope="col"  >Start</th>
                          <th scope="col" >ID</th>
                          <th scope="col" >Course</th>
                          <th scope="col" >Class</th>
                          <th scope="col" >Validity</th>
                          <th scope="col" >Expiry Date</th>
                          <th scope="col" >Last Attempt</th>
                          <th scope="col" >Days Left</th>
                          <th scope="col"  >Status</th>
                        </tr>
                    </thead>
                      <tbody id="myTable">
                      {listItems}
                      </tbody>
                    </table>
                </div>
            </div>
        </div>
    </div>
      

    {pager}

 {helperFile.footer()}
 
</div>

)
}
}


export default ModalList1
